<template>
<div class="container mx-auto bg-white md:bg-transparent flex flex-row justify-end pt-10 pl-5 pr-5 pb-10 md:pr-0">
  <slot></slot>
</div>
</template>

<script>
export default {
  name: 'AppNavigation'
}
</script>

<style scoped>

</style>
